import SeparatorIcon from '@assets/icons/chevron-back-outline-blue.svg';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import styled from 'styled-components';
export const Breadcrumb = styled(AntdBreadcrumb)`
    display: flex;
    gap: var(--spacing-2xs, 4px);

    span {
        ${FONT_FAMILY.poppins};
        ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize};
        ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
        ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight};
        color: var(--colors-text-action, #2171c6);
        cursor: pointer;
        padding: 2px;
        margin-right: 4px;
    }

    .ant-breadcrumb-item:last-child,
    .ant-breadcrumb-link {
        color: var(--colors-text-body, #50566e);
    }

    .crumbs {
        svg path {
            fill: var(--colors-text-action, #2171c6);
        }

        &:hover {
            background: var(--colors-surface-page, #e7f4ff);
            border-radius: var(--border-radius-xs_4, 4px);
            color: var(--colors-text-action-hover, #0d3e71);

            span,
            svg path {
                color: var(--colors-text-action-hover, #0d3e71);
                fill: var(--colors-text-action-hover, #0d3e71) !important;
            }
        }

        &:focus {
            background: var(--colors-surface-page, #e7f4ff);
            border-radius: var(--border-radius-xs_4, 4px);
            border: 2px solid var(--colors-border-action, #2171c6);
            outline: none;

            span,
            svg path {
                color: var(--colors-text-action, #2171c6) !important;
                fill: var(--colors-text-action, #2171c6) !important;
            }
        }

        &.ant-breadcrumb-disabled,
        &.ant-breadcrumb-disabled .ant-breadcrumb-link,
        &.ant-breadcrumb-disabled .ant-breadcrumb-separator {
            color: var(--colors-text-disabled, #b4b8bf);
            background: var(--colors-surface-disabled, #e2e8f0);
            border-radius: var(--border-radius-xs_4, 4px);
        }
    }
`;

export const SeparatorIconWrapper = styled(SeparatorIcon)`
    cursor: pointer;
    transform: rotate(180deg);
    transition: transform 0.2s ease;
    margin-bottom: -5px;
`;

export const BreadcrumbWrapper = styled.div`
    display: flex;
    padding: var(--spacing-xs, 8px) var(--spacing-md, 24px);
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
`;
